import type { FC, ReactNode } from 'react';

import type { IconName } from '@similarweb/icons';
import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { StyledCheckbox, StyledCheckboxLabel } from './styles';

export type CheckboxProps = {
  isChecked?: boolean;
  isHalfChecked?: boolean;
  onClick?: () => void;
  label?: ReactNode;
  className?: string;
  disabled?: boolean;
  labelFirst?: boolean;
  dataAutomation?: string;
};

export const Checkbox: FC<CheckboxProps> = ({
  onClick,
  isChecked,
  isHalfChecked,
  label,
  className,
  labelFirst,
  disabled,
  dataAutomation,
}) => {
  const iconName: IconName = isHalfChecked ? 'checkbox-int' : isChecked ? 'checkbox-on' : 'checkbox-off';
  const iconColor = isChecked || isHalfChecked ? colorsPalettes.blue[400] : colorsPalettes.midnight[100];

  const icon = <SWReactIcons iconName={iconName} iconColor={iconColor} size="sm" />;
  const labelElement = label ? <StyledCheckboxLabel>{label}</StyledCheckboxLabel> : null;

  return (
    <StyledCheckbox
      onClick={disabled ? undefined : onClick}
      className={className}
      disabled={disabled}
      data-automation={dataAutomation}
    >
      {labelFirst ? labelElement : icon}
      {labelFirst ? icon : labelElement}
    </StyledCheckbox>
  );
};
